export var getCurrentWindow = function getCurrentWindow(supportIFrame) {
  if (supportIFrame && window.frameElement) {
    return window.top || window;
  }

  return window;
};
export var getCurrentMQQ = function getCurrentMQQ(supportIFrame) {
  if (supportIFrame && window.frameElement) {
    var _window$top;

    return (_window$top = window.top) === null || _window$top === void 0 ? void 0 : _window$top.mqq;
  }

  return window.mqq;
};
export var getCurrentWX = function getCurrentWX(supportIFrame) {
  if (supportIFrame && window.frameElement) {
    var _window$top2;

    return (_window$top2 = window.top) === null || _window$top2 === void 0 ? void 0 : _window$top2.wx;
  }

  return window.wx;
};